module.exports = __webpack_public_path__ + "static/media/logo.7745e0c3.svg";